import { backendAxios } from "../Services/axios";

export default class GoogleController {
  static async getPlaceCoordinates(placeId: string) {
    const response = await backendAxios.get("/google/coordinates/" + placeId);
    return response.data;
  }
}
